// Last updated: 2026-06-10T00:00:00Z (Chakra v3 migration)
// =============================================
// Footer Policy Links Font Fix
//
// Makes the font of Privacy Policy and Terms of Use links match the copyright text.
// Last updated: 2025-06-27 09:00 UTC
// Console logs are added for debugging.
// =============================================
import React from 'react';
import { Box, Text, HStack, VStack } from '@chakra-ui/react';
import { useColorMode } from './components/ui/color-mode';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const { colorMode } = useColorMode();
  const linkStyle = {
    fontSize: '0.875rem',
    color: colorMode === 'dark' ? 'gray.300' : 'gray.600',
    textDecoration: 'none',
    fontFamily: 'inherit',
    fontWeight: 'normal',
    transition: 'color 0.2s',
  };
  return (
    <Box as="footer" py={6} px={8} bg={colorMode === 'dark' ? 'gray.900' : 'gray.100'} borderTop="1px solid" borderColor={colorMode === 'dark' ? 'gray.700' : 'gray.200'}>
      <VStack gap={3}>
        <Text fontSize="sm" color={colorMode === 'dark' ? 'gray.400' : 'gray.600'}>
          &copy; {new Date().getFullYear()} examgate.net. All Rights Reserved.
        </Text>
        <HStack gap={4}>
          <RouterLink to="/privacy" style={linkStyle} onMouseEnter={(e) => e.target.style.color = colorMode === 'dark' ? '#7dd3fc' : '#1e40af'} onMouseLeave={(e) => e.target.style.color = colorMode === 'dark' ? '#d1d5db' : '#4b5563'}>Privacy Policy</RouterLink>
          <Text as="span" color={colorMode === 'dark' ? 'gray.600' : 'gray.400'} fontSize="sm">|</Text>
          <RouterLink to="/terms" style={linkStyle} onMouseEnter={(e) => e.target.style.color = colorMode === 'dark' ? '#7dd3fc' : '#1e40af'} onMouseLeave={(e) => e.target.style.color = colorMode === 'dark' ? '#d1d5db' : '#4b5563'}>Terms of Use</RouterLink>
        </HStack>
        <Text fontSize="xs" color={colorMode === 'dark' ? 'gray.500' : 'gray.500'} textAlign="center" mt={1} maxW="600px">
          All trademarks are the property of their respective owners. ExamGate is not affiliated with or endorsed by any certifying organization mentioned on this site.
        </Text>
      </VStack>
    </Box>
  );
};

export default Footer; 
